import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const CricMakeAttemptUI = (props: UIProperties<CricMakeAttemptUIConfig>) => {
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<div style={{
				position: 'absolute',
				bottom: '20px',
				left: '50%',
				transform: 'translate(-50%, 0)',
				width: '990px',
				height: '170px',
				pointerEvents: 'all'
			}}>
				<img style={{
					width: '100%',
					height: '50px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					position: 'absolute',
					top: '01px',
					left: '3px',
					width: '987px',
					height: '50px',
				}}>
					<p style={{
						margin: '0px',
						fontSize: '20pt',
						textAlign: 'center',
						position: 'relative',
						top: '9px'
					}} className="title-font" tabIndex={0} id='cric-make-attempt-ui-top'>Choose your tool and select "Make Attempt".</p>
				</div>

				<div style={{
					width: '100%',
					height: '118px',
					position: 'absolute',
					top: '50px',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/SBAR/window_modal_1_edited.png"/>
					<CustomMakeAttemptButton 
						foregroundImg='./assets/images/cric/Scalpel.png'
						showYellowThingyOnTheSide={props.parameters.currentTool === 0}
						width= '140px'
						isDisabled={props.parameters.currentTool !== 0}
						position= {{
							type: 'absolute', 
							top: '7px',
							left: '60px'
						}}
						text='Scalpel'
						onClicked={() => {
						}}/>
					<CustomMakeAttemptButton 
						foregroundImg='./assets/images/cric/Spreader.png'
						showYellowThingyOnTheSide={props.parameters.currentTool === 1}
						width= '140px'
						isDisabled={props.parameters.currentTool !== 1}
						text='Spreaders / Scissors'
						position= {{
							type: 'absolute', 
							top: '7px',
							left: '270px'
						}}
						onClicked={() => {
						}}/>

					<CustomMakeAttemptButton 
						foregroundImg='./assets/images/cric/Bougie.png'
						showYellowThingyOnTheSide={props.parameters.currentTool === 2}
						width= '140px'
						isDisabled={props.parameters.currentTool !== 2}
						text='Bougie'
						position= {{
							type: 'absolute', 
							top: '7px',
							left: '450px'
						}}
						onClicked={() => {
						}}/>
					<CustomMakeAttemptButton 
						foregroundImg='./assets/images/cric/ETT.png'
						showYellowThingyOnTheSide={props.parameters.currentTool === 3}
						width= '140px'
						isDisabled={props.parameters.currentTool !== 3}
						text='ETT'
						position= {{
							type: 'absolute', 
							top: '7px',
							left: '630px'
						}}
						onClicked={() => {
						}}/>
					<CustomMakeAttemptButton 
						foregroundImg='./assets/images/cric/Syringe.png'
						showYellowThingyOnTheSide={props.parameters.currentTool === 4}
						width= '140px'
						isDisabled={props.parameters.currentTool !== 4}
						text='Syringe'
						position= {{
							type: 'absolute', 
							top: '7px',
							left: '810px'
						}}
						onClicked={() => {
						}}/>					
				</div>

				{props.parameters.currentTool === 0 ? (<div>
					<GeneralButtonWithText parameters= {{
						ariaLbl: 'Make Attempt',
						text: 'Make Attempt',
						top: '0px',
						left: '984px',
						width: '130px',
						isDisabled: false,
						srcIdle: "./assets/images/make-attempt/button_make_attempt_main.png",
						srcHighlight: "./assets/images/make-attempt/button_make_attempt_down.png",
						srcDisabled: null,
						highlightOnHover: true,
						customImgStyle: {
						},
						customButtonStyle : {
						},
						customTextStyle: {
							fontSize: '10pt',
							fontWeight: 'bold',
							top: '80px'
						},
						onClicked: () => {
							props.parameters.onMakeAttemptClicked(props.parameters.currentTool);
						}
					}}/>

					<GeneralButtonWithText parameters= {{
						text: 'Abort Attempt',
						ariaLbl: 'Abort Attempt',
						id:'cric-make-attempt-ui-bottom',
						top: '102px',
						left: '984px',
						width: '130px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						highlightOnHover: true,
						srcDisabled: null,
						customImgStyle: {
						},
						customButtonStyle : {
						},
						customTextStyle: {
							fontSize: '10pt',
							fontWeight: 'normal'
						},
						onClicked: () => {
							props.parameters.onAbortedClicked();
						}
					}}/>
				</div>) : (
					<div>
						<GeneralButtonWithText parameters= {{
							text: 'Make Attempt',
							ariaLbl: 'Make Attempt',
							id:'cric-make-attempt-ui-bottom',
							top: '8px',
							left: '984px',
							width: '190px',
							isDisabled: false,
							srcIdle: "./assets/images/make-attempt/button_make_attempt_main.png",
							srcHighlight: "./assets/images/make-attempt/button_make_attempt_down.png",
							srcDisabled: null,
							highlightOnHover: true,
							customImgStyle: {
							},
							customButtonStyle : {
							},
							customTextStyle: {
								fontSize: '16pt',
								fontWeight: 'bold',
								top: '120px'
							},
							onClicked: () => {
								props.parameters.onMakeAttemptClicked(props.parameters.currentTool);
							}
						}}/>
					</div>
				)}
			</div>
		</div>
	);

};

const CustomMakeAttemptButton = (props: CustomBVMMakeAttemptButtonConfig) => {
	// var customStyle = () => {
	// 	var r = props.isDisabled ? {
	// 		opacity: '0.5'
	// 	} : {
	// 		opacity: '1'
	// 	};

	// 	return r
	// }
	return (
		<div style={{
			position: props.position.type ? props.position.type : 'relative',
			top: props.position.top,
			left: props.position.left,
			width: props.width,
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'relative'
			}}>
				<GeneralButtonWithText parameters= {{
					text: '',
					ariaLbl: props.text,
					top: '0px',
					left: '0px',
					isDisabled: props.isDisabled,
					// customDisabledMainStyle: customStyle(),
					width: props.width,
					srcIdle: './assets/images/general/buttons/button_side_large-1.png',
					srcHighlight: null,
					srcDisabled: './assets/images/general/buttons/button_side_large_disabled.png',
					customMainStyle: {
						// position: 'relative',
						// width: props.isFlipped ? '99px' : '129px',
						// transform: props.isFlipped ? 'scaleX(-1)' : 'scaleX(1)'
					},
					onClicked: () => {
						if(props.onClicked) {
							props.onClicked();
						}
					}
				}}/>
				<div style={{
						position: 'relative',
						top: '13px',
						height: 'calc(calc(' + props.width+'/2)-3px)',
						pointerEvents: 'none',
						
				}}>
					{props.foregroundImg ? <img style={{
						position: 'relative',
						top: '0',
						left: '50%',
						transform: 'translate(-50%, 0)',
						width: 'calc(' + props.width+'/2)',
						// ...customStyle()
					}} src={props.foregroundImg} /> : (null)}
				</div>

				<div style={{
					position: 'absolute',
					height: '19px',
					pointerEvents: 'none',
					width: '70%',
					left: '12px',
					// top: props.text === 'Tool Bag' ? '69px' : undefined
				}}>
					<div style={{
						position: 'relative',
						top: '0'
					}}>
						<p className='title-font' style={{
							textAlign: 'right',
							margin: '0',
							fontSize: '8pt',
							fontWeight: 'normal'
						}}>{props.text}</p>
					</div>
					
				</div>

				{props.showYellowThingyOnTheSide ? (
					<img style={{
						position: 'absolute',
						top: 0,
						right: '-21px',
						width: '28px',
						pointerEvents: 'none'
					}} src="./assets/images/general/buttons/button_side_pointer.png" />
				) : (null)}
			</div>
		</div>
	);

};

interface CustomBVMMakeAttemptButtonConfig {
	width: string;
	position: CustomBVMMakeAttemptButtonPosition;
	foregroundImg: string;
	showYellowThingyOnTheSide?: boolean;
	isDisabled?: boolean;
	onClicked: () => void;
	text: string;
}

interface CustomBVMMakeAttemptButtonPosition {
	type?: any;
	left: string;
	top: string;
}

export interface CricMakeAttemptUIConfig extends BaseConfig{
	onAbortedClicked: () => void;
	onMakeAttemptClicked: (selectedToolIndex: number) => void;
	currentTool: number;
}

export default CricMakeAttemptUI;